"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Introduction() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: buttonRef,
    isVisible: buttonVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section id="introduction" className="py-20 bg-primary-light">
      <div className="container">
        <div className="max-w-4xl mx-auto">
          <h2 ref={headerRef} className="text-center mb-8 transition-all duration-500 opacity-100 translate-y-0 !font-serif !text-xl">Welcome to Unity Language Academy!</h2>
          
          <div ref={textRef} className={`text-lg text-foreground leading-relaxed mb-10 text-left md:text-left transition-all duration-500 delay-100 ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <p className="mb-4 !text-justify">At Unity Language Academy, we are dedicated to empowering French-speaking students with the language skills they need to succeed globally. Whether you're preparing for IELTS or TOEFL exams, seeking to improve your general English proficiency, or learning German from scratch, our expert instructors and proven methodologies will guide you every step of the way.</p>
            <p className="!text-justify">Our mission is to provide a supportive, flexible, and results-driven learning environment that helps you achieve your academic, professional, and immigration goals. Join us and unlock new opportunities through language mastery.</p>
          </div>

          <div ref={buttonRef} className={`flex justify-center transition-all duration-500 delay-200 ${buttonVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Button asChild className="btn-primary">
              
            </Button>
          </div>
        </div>
      </div>
    </section>;
}